<template>
  <BModal
    id="modal-paid-verification"
    ref="modal-paid-verification"
    hide-header-close
    hide-footer
    no-close-on-esc
    no-close-on-backdrop
    hide-header
    :centered="true"
  >
    <div class="flex flex-col text-black items-center jusfify-center gap-4 p-1">
      <div class="font-semibold text-xl">
        Verifikasi Sekali untuk Seumur Hidup
      </div>
      <img
        src="https://storage.googleapis.com/komerce/Komcards/glass%20security%20shield.svg"
        alt="Komerce"
        width="100"
      >
      <div class="text-xl">
        Hanya <span class="font-semibold">{{ IDR(25000) }}</span>
      </div>
      <div class="border rounded-xl p-1">
        <div
          v-for="f in features"
          :key="f.title"
          class="flex items-start gap-2 mb-[5px]"
        >
          <img
            src="https://storage.googleapis.com/komerce/assets/icons/Checklist-fill.svg"
            alt="Komerce"
            width="25"
          >
          <div class="flex flex-col">
            <div>{{ f.title }}</div>
            <div class="text-sm text-[#828282]">
              {{ f.desc }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="flex items-center gap-2">
      <BButton
        block
        variant="outline-primary"
        @click="onCancel"
      >
        Batal
      </BButton>
      <BButton
        block
        variant="primary"
        class="m-0"
        :disabled="loadingBalance || loadingPaid"
        @click="onSubmit"
      >
        <BSpinner
          v-if="loadingBalance || loadingPaid"
          small
        />
        Verifikasi Sekarang
      </BButton>
    </div>
  </BModal>
</template>

<script>
import { IDR } from '@/libs/currency'
import { komshipAxiosIns, newAxiosIns } from '@/libs/axios'

export default {
  data() {
    return {
      IDR,
      idPartner: this.$store.state.auth.userData.id,
      loadingBalance: false,
      loadingPaid: false,
      balance: null,
      minPaid: 25000,
      features: [
        {
          title: 'Gratis 5 Kartu Komcards',
          desc: 'Kamu bebas membuat 5 Kartu Pertama di Komcards',
        },
        {
          title: 'Akun Lebih Terpercaya',
          desc: 'Mengurangi risiko pemblokiran dan kendala operasional',
        },
        {
          title: 'Verifikasi 1x untuk semua kebutuhan',
          desc: 'Lebih praktis saat menggunakan berbagai fitur dan produk',
        },
        {
          title: 'Akses Fitur & Produk Komerce',
          desc: 'Mendapatkan akses penuh ke Fitur & Produk Komerce di kemudian hari',
        },
      ],
    }
  },
  methods: {
    async onSubmit() {
      this.loadingBalance = true
      const url = 'komship/api/v1/dashboard/partner/balanceSummary'
      await newAxiosIns
        .get(url)
        .then(res => {
          const {
            data: { balance },
          } = res.data
          this.loadingBalance = false
          if (balance < this.minPaid) {
            this.$router.push('/?source=paid-verification')
          } else {
            this.paidVerification()
          }
        })
        .catch(() => {
          this.loadingBalance = false
          this.$toast_error({
            message: 'Gagal load data balance, silahkan coba lagi',
          })
        })
    },
    async paidVerification() {
      this.loadingPaid = true
      const url = '/auth/api/v1/partner/ktp-verification/pay'
      await newAxiosIns.post(url)
        .then(async () => {
          this.loadingPaid = false
          await this.$store.dispatch('dashboard/getProfile').then(() => {
            this.$bvModal.hide('modal-paid-verification')
            this.$toast_success({
              message: 'Paid Verif telah berhasil dibeli',
            })
          })
        })
        .catch(() => {
          this.loadingPaid = false
          this.$toast_error({
            message: 'Paid Verif gagal dibeli',
          })
        })
    },
    onCancel() {
      this.$bvModal.hide('modal-paid-verification')
      this.$router.back()
    },
  },
}
</script>
